import { Component, computed, input, ViewEncapsulation } from '@angular/core';

export type RibbonColor = 'yellow';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-ribbon',
	templateUrl: './ribbon.html',
})
export class RibbonComponent {
	readonly text = input.required<string>();
	readonly maxLength = input(10);

	readonly ribbonText = computed(() =>
		this.text().slice(0, this.maxLength()),
	);
}
